import React from "react";
import { useEffect, useState } from "react";

export default function ProgressLine({ editable, goal, index, completion, currentIndex, length, active, offsetUnits, updateCompletion, updateTitleIndex }) {
    const [complitionOffset, setComplitionOffset] = useState(15);

    function lengthInex2offset() {
        const odd = length % 2;
        const middle = length / 2
        const newIndex =
            middle <= index
                ? index + 1 - middle - odd / 2
                : index - middle + odd / 2
        const offset =
            (middle <= index
                ? offsetUnits.x * newIndex - !odd * offsetUnits.x / 2
                : offsetUnits.x * newIndex + !odd * offsetUnits.x / 2) * -1
        return (offset)
    }
    const Xoffset = lengthInex2offset();
    const padding = 6
    const width = length * offsetUnits.x + padding * 2;
    const center = width / 2;
    const top = padding;
    const bottom = offsetUnits.y * 6 + 54;
    const bottomProgress = bottom - 48;

    const [isActive, setIsActive] = useState(false);
    const [mouseY, setMouseY] = useState(null);
    const [isDragging, setIsDragging] = useState(false);
    const [completionTemp, setComplitionTemp] = useState(null);

    const handleMouseMove = (event) => {
        if (isDragging) {
            const { clientY } = event;
            const oldY = mouseY;
            const newY = clientY;
            const travel = newY - oldY;
            const newOffset = complitionOffset - travel;
            const newCompletionTemp = Math.round(newOffset / offsetUnits.y);
            if (travel === 1 || travel === -1) {// there is a big jump in the beging going only by one avoids it
                if (newCompletionTemp !== completionTemp) {//when it comes to a new whole value update the name
                    updateTitleIndex(newCompletionTemp);
                    setComplitionTemp(newCompletionTemp);
                }
                if (
                    oldY !== null &&
                    newOffset >= 0 && // bottom limit
                    newOffset <= (bottomProgress - padding) // top limit
                ) {
                    setComplitionOffset(newOffset);
                }
            }
            setMouseY(newY);
        }
    };
    useEffect(() => {
        if (editable) {
            if (!isDragging) {
                setComplitionOffset(completion * offsetUnits.y)
            }
        } else {
            setComplitionOffset(goal.completion * offsetUnits.y)
        }
    }, [goal, completion, offsetUnits, isDragging, editable]);
    useEffect(() => {
        setComplitionTemp(null)
    }, [index])
    return (
        <g>
            {!active && <path
                //this is the dotted line that doesn't change
                stroke="black"
                strokeWidth="3"
                markerEnd="url(#circle-black)"
                markerStart="url(#circle-black)"
                strokeDasharray="5 2"
                d={`M${center} ${bottom}  V ${bottom - 10} C ${center} ${bottom - 20}, ${center - Xoffset} ${bottom - 20}, ${center - Xoffset} ${bottom - 40}V ${top} `}
            />}
            {editable ?
                <React.Fragment>
                    <path
                        //this is the white line it is interactive if editable is enabled
                        strokeWidth={active ?
                            isActive ?
                                "8"
                                :
                                "5"
                            :
                            "4"}
                        markerEnd={active ?
                            isActive ?
                                "url(#circle-orange)"
                                :
                                "url(#circle-white)"
                            :
                            "url(#circle-black)"}
                        markerStart={active ? "url(#circle-white)" : "url(#circle-black)"}
                        stroke={active ? "white" : "black"}
                        d={`M${center} ${bottom}  V ${bottom - 10} C ${center} ${bottom - 20}, ${center - Xoffset} ${bottom - 20}, ${center - Xoffset} ${bottom - 40}V ${complitionOffset ? (bottomProgress - complitionOffset) : bottomProgress} `}
                    />
                    {/* This rectangle serves as a dragging field */}
                    <rect x={center - Xoffset - 20} y="-10px" width="40px" fill="transparent" height={bottom}
                        draggable
                        className="draggable"
                        onMouseEnter={() => {
                            setIsActive(true);
                        }}
                        onMouseLeave={() => {
                            setIsActive(false);
                            setIsDragging(false);
                            if (completionTemp !== null) { updateCompletion(completionTemp); }
                        }}
                        onMouseMove={handleMouseMove}
                        onMouseDown={() => {
                            setIsDragging(true);
                        }}
                        onMouseUp={() => {
                            setIsDragging(false);
                            if (completionTemp !== null) { updateCompletion(completionTemp); }
                        }}
                    />
                </React.Fragment>
                : (
                    index !== currentIndex && <path
                        //this white/black line only shows the current completion level and is not interactive
                        strokeWidth={active ? "5" : "4"}
                        markerEnd={active ? "url(#circle-white)" : "url(#circle-black)"}
                        markerStart={active ? "url(#circle-white)" : "url(#circle-black)"}
                        stroke={active ? "white" : "black"}
                        d={`M${center} ${bottom}  V ${bottom - 10} C ${center} ${bottom - 20}, ${center - Xoffset} ${bottom - 20}, ${center - Xoffset} ${bottom - 40}V ${complitionOffset ? (bottomProgress - complitionOffset) : bottomProgress} `}
                    />
                )
            }
        </g>
    )
}